import { tabRemoved } from 'epic/workspace/common/tabs/tabsEpics/tabRemoved';
import { EMPTY } from 'rxjs';
import { filter, map, mergeMap, startWith, takeUntil, withLatestFrom } from 'rxjs/operators';
import type { Action } from 'state/actions';
import { ScreenMode } from 'state/quoteWorkspace';
import type { EpicWithThunk } from 'state/state.common';
import type { WorkspaceType } from 'state/workspaces/model';
import { workspaceTabFrozen, workspaceTabUnfrozen } from 'state/workspaces/workspace.actions';
import { sessionSynchronization } from 'utils/streaming/messages';

function asWorkspaceType(screenMode: ScreenMode | undefined): WorkspaceType | undefined {
  if (screenMode === ScreenMode.STATIC) {
    return 'static';
  } else if (screenMode === ScreenMode.DYNAMIC) {
    return 'dynamic';
  }
}
export function sessionQuotingEpic(): EpicWithThunk {
  return (action$, state$, { selectors: { getTabIdFromNegotiationId }, streaming }) =>
    sessionSynchronization(streaming).pipe(
      filter(({ type }) => type === 'SessionQuoting'),
      withLatestFrom(state$),
      mergeMap(([sessionEvent, state]) => {
        const negotiationId = sessionEvent.negotiationId;
        const { screenMode, tabId } = getTabIdFromNegotiationId(state, negotiationId);
        const workspace = asWorkspaceType(screenMode);
        if (workspace !== undefined && tabId !== undefined) {
          const tabRemoved$ = tabRemoved(action$, tabId, state$);

          const res$ = sessionSynchronization(streaming).pipe(
            takeUntil(tabRemoved$),
            filter(e => e.negotiationId === negotiationId),
            filter(
              e => e.type === 'SessionQuoted' || e.type === 'SessionQuoteError' || e.type === 'SessionQuoteCancelled',
            ),
            map(() => <Action>workspaceTabUnfrozen(tabId, workspace, false)),
            startWith(workspaceTabFrozen(tabId, workspace, true)),
          );
          return res$;
        }

        return EMPTY;
      }),
    );
}
